import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import {
  useAppStore,
  useFloorsStore,
  useMessagingStore,
} from '@/stores'
import ConfirmationDialogWrapper from '@/components/ConfirmationDialogWrapper.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// service
const floorsStore = useFloorsStore()
const appStore = useAppStore();
const messagingStore = useMessagingStore();

const fullScreenRef = ref();

onMounted(() => {
  appStore.$patch({'fullScreenElRef': fullScreenRef.value.$el})
});


return { __sfc: true,floorsStore, appStore, messagingStore, fullScreenRef, ConfirmationDialogWrapper }
}

})